import { func_file, isNumberValid } from 'functions';
import { useCustomSelector } from 'hooks';

export default function useExportData() {
    let {
        allOutletSTList
    } = useCustomSelector("outlet");

    function exportData() {
        // Set Header Names
        let headers = [
            [
                "Outlet ID",
                "Outlet Name",
                "ST Last 2 Month",
                "ST Last 1 Month",
                "ST Render Month",
                "First Day Of ST Render Month",
                "Last Day Of ST Render Month",
            ]
        ];

        // Columns Widths
        let columnWidths = headers[0].map((header, idx) => {
            return {
                wch: idx == 1 || idx == 2? 50: header.length
            }
        });

        // Set rows data
        let rows = allOutletSTList.map((rowDetail) => {
            return [
                (rowDetail?.OutletID? rowDetail.OutletID: ""),
                (rowDetail?.OutletName? rowDetail.OutletName: ""),
                (isNumberValid(rowDetail?.STLast2Month)? rowDetail.STLast2Month: ""),
                (isNumberValid(rowDetail?.STLastMonth)? rowDetail.STLastMonth: ""),
                (isNumberValid(rowDetail?.STRenderMonth)? rowDetail.STRenderMonth: ""),
                (rowDetail?.FirstDayOfSTRenderMonth? rowDetail.FirstDayOfSTRenderMonth: ""),
                (rowDetail?.LastDayOfSTRenderMonth? rowDetail.LastDayOfSTRenderMonth: ""),
            ]
        });

        func_file.generateFile_XLSX("Transaction History Report", "Transaction History", headers, rows, null, null, columnWidths);
    }

    return exportData;
}